import AuthReducer from '../features/auth/AuthSlice'

const rootReducer = {
  AuthReducer,
}

export default rootReducer
